<template>
<div>
  <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" class="title-bar" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
  <el-row v-loading="isLoading">
    <div class="title-h3 title-bar">캐시 적중률</div>
    <el-row type="flex">
      <el-col :span="8">
        <div class="title-h4 title-bar">버퍼캐시 적중률</div>
        <w-cache-hitratio-chart :performanceData="performanceData" cacheKey="MEMSTAT/DB_BUF_CACHE_HITRATIO" />
      </el-col>
      <el-col :span="8">
        <div class="title-h4 title-bar">>SGA Lib Cache 적중률</div>
        <w-cache-hitratio-chart :performanceData="performanceData" cacheKey="MS_MEMSTAT/DBMS_PROCEDURE_CACHE_HITRATIO" />
      </el-col>
      <el-col :span="8">
        <div class="title-h4 title-bar">>SGA Dic Cache 적중률</div>
        <w-cache-hitratio-chart :performanceData="performanceData" cacheKey="MS_MEMSTAT/DBMS_LOG_CACHE_HITRATIO" />
      </el-col>
    </el-row>
    <div class="title-h3 title-bar">메모리 정보</div>
    <el-row type="flex">
      <el-col :span="8">
        <w-memory-pie-chart :performanceData="performanceData" :objtypeId="objtypeId" />
      </el-col>
      <el-col :span="16" class="list form-list">
        <el-row type="flex" :gutter="20">
          <el-col :span="12">
            <el-form v-if="performanceData !== null" :model="performanceData">
              <el-form-item v-for="{rsctypeId, rscId} in firstRscInfoList" :key="`${rsctypeId}.${rscId}`" :label="performanceData[`${rsctypeId}/${rscId}/NAME`]">
                {{ convertMemoryInfoData(performanceData[`${rsctypeId}/${rscId}`], performanceData[`${rsctypeId}/${rscId}/UNIT`]) }}
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form v-if="performanceData !== null" :model="performanceData">
              <el-form-item v-for="{rsctypeId, rscId} in secondRscInfoList" :key="`${rsctypeId}.${rscId}`" :label="performanceData[`${rsctypeId}/${rscId}/NAME`]">
                {{ convertMemoryInfoData(performanceData[`${rsctypeId}/${rscId}`], performanceData[`${rsctypeId}/${rscId}/UNIT`]) }}
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</div>
</template>

<script>
import { isNil, pullAt, clone } from 'lodash';

import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT } from '@/utils/string';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import { analysisTimeType } from '@/constants/performance';
import DatabaseAPI from '@/api/performance/database/database-table-info';
import msgUtil from '@/utils/message';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WCacheHitratioChart from '../../chart/CacheHitratioChart';
import WMemoryPieChart from '../../chart/MemoryPieChart';

export default {
  name: 'WMemoryMssql',
  mixins: [AnalysisTableMixin],
  components: {
    WCacheHitratioChart,
    WMemoryPieChart,
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      isLoading: false,
      checkDatetime: null,
      rscInfoList: [
        {
          rsctypeId: 'MEMSTAT',
          rscId: 'DB_BUF_CACHE_HITRATIO',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_PROCEDURE_CACHE_HITRATIO',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_LOG_CACHE_HITRATIO',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_MEM_TOTAL_SIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_MEM_USEDSIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_MEM_USEDRATE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_BUF_CACHE_TOTAL_SIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_BUF_CACHE_USEDSIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_BUF_CACHE_USERATE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_PROCEDURE_CACHE_TOTAL_SIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_PROCEDURE_CACHE_USEDSIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_PROCEDURE_CACHE_USERATE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_BUF_POOL_AVSIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_BUF_POOL_RESERVED_SIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_BUF_POOL_SERVER_SIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_BUF_POOL_TOTAL_SIZE',
          rscKey: '_',
        },
        {
          rsctypeId: 'MS_MEMSTAT',
          rscId: 'DBMS_BUF_POOL_USED_SIZE',
          rscKey: '_',
        },
      ],
      performanceData: {},
      firstRscInfoList: [],
      secondRscInfoList: [],
    };
  },
  computed: {
    objtypeId() {
      return isNil(this.selectedNode) ? null : this.selectedNode.obj.objtypeId;
    },
  },
  methods: {
    /**
     * 성능 데이터를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      const rscIds = [];
      this.rscInfoList.forEach((item) => {
        rscIds.push(item.rscId);
      });
      const params = {
        objId: this.selectedNode.obj.objId,
        rscIds,
      };

      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        params.objtypeId = this.selectedNode.obj.objtypeId;
        this.isLoading = true;
        DatabaseAPI.getCurrentPerformanceList(params)
          .then((response) => {
            if (response.data.success) {
              this.performanceData = response.data.data;
              const rscInfoList = clone(this.rscInfoList);
              pullAt(rscInfoList, [0, 1, 2]);
              const length = rscInfoList.length;
              this.firstRscInfoList = rscInfoList.slice(0, length / 2);
              this.secondRscInfoList = rscInfoList.slice(length / 2, length);
            } else {
              this.failToLoadData();
            }
          })
          .catch(() => {
            this.failToLoadData();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        params.baselineDatetime = this.plotLineDatetime;
        params.managetypeId = 'DBMS';
        params.rsctypeId = 'MS_MEMSTAT';
        this.isLoading = true;
        DatabaseAPI.getPerformanceList(params)
          .then((response) => {
            if (response.data.success) {
              const result = response.data.data;
              this.performanceData = result.snapshotDoc;
              this.checkDatetime = result.timestamp;

              const rscInfoList = clone(this.rscInfoList);
              pullAt(rscInfoList, [0, 1, 2]);
              const length = rscInfoList.length;
              this.firstRscInfoList = rscInfoList.slice(0, length / 2);
              this.secondRscInfoList = rscInfoList.slice(length / 2, length);
            } else {
              this.failToLoadData();
            }
          })
          .catch(() => {
            this.failToLoadData();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    /**
     * 성능 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '메모리 정보', false));
    },
    /**
     * 메모리 정보 폼의 데이터를 converting한다.
     * @param  {[type]} memoryInfoData [description]
     * @param  {[type]} unit           [description]
     * @return {[type]}                [description]
     * @author jda
     */
    convertMemoryInfoData(memoryInfoData, unit) {
      if (isNil(memoryInfoData)) {
        return EMPTY_TEXT;
      }
      return convertValuByUnit(memoryInfoData, unit, true);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/MemoryInfo/MemoryMssql.vue